// The dedicated Work hub is retired. Chat ⇄ Work lives on the normal new-chat
// home (`/app` + composerMode). Keep this route so old /coworker links still
// land on the unified composer. Only Plus members may enter Work mode.
import { useEffect, useState } from 'react';
import { Redirect } from 'expo-router';
import { useAuthStore, useCoworkerStore, useModalStore } from '@/store';
import { isWorkModeDisabled, notifyWorkModeUnavailable } from '@/lib/workModeAvailability';

export default function CoworkerHomeRedirect() {
  const isPlus = useAuthStore((state) => state.user?.flags?.isPlus === true);
  const token = useAuthStore((state) => state.token);
  const isTokenExpired = useAuthStore((state) => state.isTokenExpired);
  const { openModal } = useModalStore((state) => state.actions);
  const [isReadyToRedirect, setIsReadyToRedirect] = useState(false);

  useEffect(() => {
    const coworkerStore = useCoworkerStore.getState();
    if (isWorkModeDisabled()) {
      coworkerStore.setComposerMode('chat');
      if (token && !isTokenExpired()) notifyWorkModeUnavailable();
      setIsReadyToRedirect(true);
      return;
    }
    if (isPlus) {
      coworkerStore.setComposerMode('coworker');
      setIsReadyToRedirect(true);
      return;
    }
    coworkerStore.setComposerMode('chat');
    if (token && !isTokenExpired()) {
      openModal('PlusFeatureModal', { feature: 'work' });
    }
    setIsReadyToRedirect(true);
  }, [isPlus, isTokenExpired, openModal, token]);

  if (!isReadyToRedirect) return null;
  return <Redirect href="/app" />;
}
